var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "waiting__container" }, [
    _c("div", { staticClass: "waitingView" }, [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "waiting__text",
          attrs: { tabindex: "0", "aria-live": "assertive" },
        },
        [
          _c("p", [
            _vm._v(
              " " +
                _vm._s(
                  this.queue_postition > 0
                    ? _vm.$gettextInterpolate(
                        _vm.$gettext(
                          "Estás en el puesto %{ queue_position } de la cola"
                        ),
                        { queue_position: this.queue_postition }
                      )
                    : _vm.$gettext("En cola")
                ) +
                " "
            ),
          ]),
          _c("span", [
            _vm._v(
              " " +
                _vm._s(
                  this.waiting_time > 0
                    ? _vm.$gettextInterpolate(
                        _vm.$gettext(
                          "El tiempo aproximado de espera es de %{ waiting_time } minutos"
                        ),
                        { waiting_time: this.waiting_time }
                      )
                    : _vm.$gettext(
                        "En breves momentos serás atendido/a por uno de nuestros agentes. Por favor, mantente a la espera"
                      )
                ) +
                " "
            ),
          ]),
        ]
      ),
    ]),
    _c("div", { staticClass: "waiting__options", attrs: { tabindex: "0" } }, [
      _c("p", [
        _vm._v(" " + _vm._s(_vm.$gettext("¿Prefieres evitar la espera?"))),
      ]),
      _c("div", { staticClass: "form-button-container" }, [
        _c(
          "button",
          { attrs: { name: "contactForm" }, on: { click: _vm.offlineForm } },
          [_vm._v(_vm._s(_vm.$gettext("Formulario de contacto")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "waitingView__icon" }, [
      _c("i", { staticClass: "icon-clock" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }